





































import { computed, defineComponent } from "@vue/composition-api";
import { Transaction } from "@scrile/api-provider/dist/api/TransactionProvider";
import emitter from "@/lib/emitter";
import { $t } from "@/lib/i18nHelpers";
import config from "@/config";
import { EVENTS } from "@/const";
import BaseButton from "@/components/BaseButton";
import BasePage from "@/components/BasePage";
import BaseTooltip from "@/components/BaseTooltip";
import ComplianceContactsInfo from "@/components/ComplianceContactsInfo";
import EmptyContent from "@/components/EmptyContent";
import FormatMoney from "@/components/FormatMoney";
import InfiniteScroll from "@/components/InfiniteScroll";
import PageTitle from "@/components/PageTitle";
import TransactionItem from "./TransactionItem.vue";

export default defineComponent({
  name: "BalanceView",
  components: {
    ComplianceContactsInfo,
    BaseTooltip,
    TransactionItem,
    FormatMoney,
    BasePage,
    BaseButton,
    PageTitle,
    EmptyContent,
    InfiniteScroll,
  },
  props: {
    loading: { type: Boolean, required: true },
    enableScroll: { type: Boolean, required: true },
    balance: { type: Number, required: true },
    transactionsList: { type: Array as () => Transaction[], required: true },
  },
  setup(props) {
    const featureBalanceRefill = computed(() => config.featureBalanceRefill);
    const emptyTransactions = computed(() => !props.loading && props.transactionsList.length === 0);
    const paidFromCardText = computed(() => {
      return (
        $t("balance top up") +
        (config.featurePurchaseFromBalance ? "" : ", " + $t("purchasing posts and message attachments")) +
        (config.featureSubscribeFromBalance ? "" : ", " + $t("subscription purchases"))
      );
    });
    const paidFromBalanceText = computed(() => {
      return (
        (config.featurePurchaseFromBalance ? $t("purchasing posts and message attachments") + ", " : "") +
        (config.featureSubscribeFromBalance ? $t("subscription purchases") + ", " : "") +
        $t("sending messages, making calls, tipping.")
      );
    });

    const showRefill = () => {
      emitter.emit(EVENTS.BALANCE_REFILL_SHOW, true);
    };

    return {
      emptyTransactions,
      featureBalanceRefill,
      paidFromCardText,
      paidFromBalanceText,
      showRefill,
    };
  },
});
